import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import withHover from 'WithHover';
import * as TooltipTourActions from 'SelfServeTooltipTour/TooltipTourActions';


export class TooltipToolItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    const rect = this.props.toolboxRef.current.getBoundingClientRect();
    this.props.setTooltipLocation(rect, this.props.tooltipName);
    if (this.props.tooltipNameAlt) {
      this.props.setTooltipLocation(rect, this.props.tooltipNameAlt);
    }
  }

  onClick() {
    this.props.showToolboxTip(this.props.tooltipName);
  }

  render() {
    return (
      <div
        className="tool-item-container"
        ref={this.props.toolboxRef}
      >
        <button
          className="tip-tool-item-button"
          onClick={this.onClick}
        >
          Tips
          <div className="tip-tool-item-img-container">
            <img
              alt="Tips"
              className="tip-tool-item-img"
              src="/images/self-serve-builder/tooltip-tour-images/tip-question-icon-2x.png"
            />
          </div>
        </button>
      </div>
    );
  }
}

TooltipToolItem.defaultProps = {
  activeToolboxItem: '',
  setTooltipLocation: () => null,
  showToolboxTip: () => null,
  tooltipNameAlt: null,
};

TooltipToolItem.propTypes = {
  setTooltipLocation: PropTypes.func,
  showToolboxTip: PropTypes.func,
  toolboxRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  tooltipName: PropTypes.string.isRequired,
  tooltipNameAlt: PropTypes.string,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    setTooltipLocation: TooltipTourActions.setTooltipLocation,
    showToolboxTip: TooltipTourActions.showToolboxTip,
  }, dispatch)
);

const TooltipToolItemWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(TooltipToolItem);

export default withHover(TooltipToolItemWithRedux);



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderToolbox/TooltipToolItem.jsx